import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

const navLinks = [
  { to: "/", label: "首页" },
  { to: "/scoops", label: "爆料库" },
  { to: "/verify", label: "求证中心" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

interface SiteHeaderProps {
  activePath?: string;
}

export default function SiteHeader({ activePath = "" }: SiteHeaderProps) {
  const isActive = (to: string) =>
    to === "/" ? activePath === "/" : activePath.startsWith(to);

  return (
    <header className="border-b border-background-200 bg-background-50">
      <div className="mx-auto flex h-16 max-w-[1200px] items-center justify-between gap-6 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label={`${site.name} 首页`}>
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-shield-star-line text-[18px]" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-lg font-bold text-foreground-950">{site.name}</span>
            <span className="font-label text-[10px] tracking-widest text-foreground-500 mt-0.5">
              {site.slogan}
            </span>
          </span>
        </Link>

        <nav aria-label="主导航" className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className={`rounded-md px-4 py-2 text-sm transition-colors whitespace-nowrap ${
                isActive(link.to)
                  ? "bg-foreground-950 text-background-50 font-medium"
                  : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <Link
            to="/contact"
            className="hidden sm:inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-accent-600 whitespace-nowrap"
          >
            <i className="ri-send-plane-line" aria-hidden="true"></i>
            提供线索
          </Link>
        </div>
      </div>

      <nav aria-label="移动端导航" className="flex items-center gap-1 overflow-x-auto border-t border-background-200 px-4 py-2 md:hidden">
        {navLinks.map((link) => (
          <Link
            key={link.to}
            to={link.to}
            className={`rounded-full px-3 py-1.5 text-[13px] whitespace-nowrap transition-colors ${
              isActive(link.to)
                ? "bg-foreground-950 text-background-50"
                : "text-foreground-600 hover:bg-background-100"
            }`}
          >
            {link.label}
          </Link>
        ))}
      </nav>
    </header>
  );
}